import { useState } from 'react'
import styled from 'styled-components'
import { IsFullCenterProps } from '../Layout/CommonStyle'

type Props = {
  isWaiting: boolean
  isFullCenter?: boolean
  children?: React.ReactChild
}
function Waiting(props: Props) {
  return (
    <>
      {props.isWaiting ? (
        <SpinnerContainer isFullCenter={props.isFullCenter}>
          <LoadingSpinner />
        </SpinnerContainer>
      ) : (
        <>{props.children}</>
      )}
    </>
  )
}
const SpinnerContainer = styled.div`
  width: ${(props: IsFullCenterProps) =>
    props.isFullCenter ? '100%' : 'fit-content'};
  display: grid;
  justify-content: center;
  align-items: center;
`
const LoadingSpinner = styled.div`
  width: 20px;
  height: 20px;
  border: 5px solid #f3f3f3; /* Light grey */
  border-top: 5px solid #383636; /* Blue */
  border-radius: 50%;
  animation: spinner 1.5s linear infinite;
  @keyframes spinner {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`
export default Waiting
